import { message } from 'antd';
export {};

(Date as any).prototype.format = function (fmt: any) {
    let o: any = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return fmt;
};

(Array as any).prototype.insert = function (index: number, data: any) {
    this.splice(index, 0, data);
};

// (Array as any).prototype.splice = function(start:number, lang:number, data:any) {
//     this.splice(start, lang, data);
// };

(Array as any).prototype.delete = function (index: number, data: any) {
    this.splice(index, 1);
};

//Copy Text
(Window as any).prototype.copy = (text: any): Promise<void> => {
    try {
        var textArea: any = document.createElement('textarea');
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
        } catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(textArea);
        return Promise.resolve();
    } catch (e) {
        console.error('copy error', e);
        return Promise.reject();
    }
};

//Open Browser
(Window as any).prototype.openUrl = (url: string): Promise<void> => {
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
        try {
            let msg = {
                type: 'EVENT_OPEN_BROWSER',
                value: url,
            };
            (window as any).ReactNativeWebView.postMessage(JSON.stringify(msg));
        } catch (e) {
            window.open(url);
        }
    } else {
        window.open(url);
    }
    return Promise.resolve();
};

(Window as any).prototype.toast = message;
(Window as any).prototype.toastError = (e: any): void => {
    try {
        const _errorResult = JSON.parse(e);
        if (window.localStorage.getItem('lange') === 'en_US') {
            if (_errorResult.error.details[0].message === 'assertion failure with message: Voter can only vote or subvote once a day') {
                message.error('Please operate 24 hours after changing/cancelling vote');
            } else {
                message.error(_errorResult.error.details[0].message);
            }
        } else {
            if (_errorResult.error.details[0].message === 'assertion failure with message: Voter can only vote or subvote once a day') {
                message.error('请在上次改票/撤票24小时后再操作');
            } else if (_errorResult.error.details[0].message === 'assertion failure with message: votes insufficent') {
                message.error('选票不足');
            } else if (_errorResult.error.details[0].message === 'assertion failure with message: This account already has a vote refund') {
                message.error('需等待上次撤票到账');
            } else if (_errorResult.error.details[0].message === 'assertion failure with message: overdrawn balance') {
                message.error('余额不足');
            } else if (_errorResult.error.details[0].message === 'assertion failure with message: producers no change') {
                message.error('列表未发生变化');
            } else if (_errorResult.error.details[0].message === 'assertion failure with message: This account already has a vote refund') {
                message.error('上轮撤票后的72小时内不可以撤票');
            } else {
                message.error(_errorResult.error.details[0].message);
            }
        }
    } catch (e) {
        // message.error('ERROR');
    }
};
